import '@cloudscape-design/global-styles/index.css';
import { Layout } from '../components/layout';
import { useNavigate } from 'react-router-dom';
import { BreadcrumbGroup, Header, SpaceBetween } from '@cloudscape-design/components';


export default function SFDCTagging() {
    const navigate = useNavigate();

    // rum?.recordPageView('home');
    const breadcrumbs = (
        <BreadcrumbGroup
            onClick={({ detail }) => navigate(detail.href)}
            items={[
                { text: "Home", href: "/" },
                { text: "SFDC Tagging Guide", href: `/sfdc-tagging` },
            ]}
        />
    );
    return (
        <Layout breadcrumbs={breadcrumbs}>
            <SpaceBetween direction='vertical' size='l'>
                <Header
                    variant="h1">Salesforce Opportunity Tagging Guide</Header>
                <p>
                    To track usage of the demo portal and understand how demos are influincing and driving sales opportunities,
                    each demo within the EdTech Demo Portal contains a SFDC Tag that can be applied to the opportunity.
                </p>
                <p>
                    This guide will walk you through the few short steps to tag your SFDC opportunity.
                </p>
                <ol>
                    <li><SpaceBetween direction='vertical' size='s'>
                        <span style={{ fontWeight: 'bold' }} >Identify the demo's SFDC Tag Category & Tag Name</span>
                        <ul>
                            <li>
                                <i>From the Demo Portal Dashboard</i><br />
                                <img src="/images/sfdc-tagging/demo-tiles-view.png" alt="Screenshot of a Demo Tile from the dashboard, highlighting the SFDC Tag Category & Name." height="400px" /></li>
                            <li>
                                <i>From the Demo Portal Details Page</i><br />
                                <img src="/images/sfdc-tagging/demo-details-view.png" alt="Screenshot of the Demo Details Page, highlighting the SFDC Tag Category & Name." height="500px" />
                            </li>
                        </ul>
                        <br />
                    </SpaceBetween></li>
                    <li>
                        <SpaceBetween direction='vertical' size='s'>
                            <span style={{ fontWeight: 'bold' }} >Locate tagging in the SFDC Opportunity and click "Manage"</span>
                            <img src="/images/sfdc-tagging/opportunity-detail.png" alt="Screenshot of the SFDC Opportunity Details with Tagging Highlighted"
                                height="500px"
                            />
                            <br />
                        </SpaceBetween>
                    </li>
                    <li><SpaceBetween direction='vertical' size='s'>
                        <span style={{ fontWeight: 'bold' }} >Now apply the tag</span>
                        <ol>
                            <li>In the SFDC "Manage Tags" view, select the "Filter" that matches the SFDC Tag Category associated with the demo (e.g. Use Case, Solution).</li>
                            <li>Paste the SFDC Tag Name associated with the demo into the search box.</li>
                            <li>Click "+ Add" on the listed use case.</li>
                            <li>Click the "Save" button to apply the tagging.</li>
                        </ol>
                        <img src="/images/sfdc-tagging/sfdc-tagging-screen.png" alt="Screenshot of the SFDC Tagging View, with categories, search filter and add button highlighted"
                            height="500px"
                        />
                    </SpaceBetween></li>
                    <li>
                        <SpaceBetween direction='vertical' size='s'>
                            <span style={{ fontWeight: 'bold' }} >Verify the tag has been applied</span>
                            <img src="/images/sfdc-tagging/sfdc-opp-tagged-screen.png" alt="Screenshot of the SFDC Opportunity with the correct tag applied"
                                height="500px"
                            />
                        </SpaceBetween>
                    </li>

                </ol>
            </SpaceBetween>
        </Layout >
    );
}

